import { connect } from 'react-redux';
import { updateWorklistViews } from './worklist-actions';
import ManageViews from '../components/toolbar/manage-views-sidepanel';

const mapStateToProps = state => ({
  views: state.worklist.views,
  isLoadingViews: state.worklist.isLoadingViews,
  isSaving: state.worklist.isSavingViews,
  saveSuccess: state.worklist.saveViewsSuccess,
  error: state.worklist.error,
  activeView: state.worklist.activeView,
});

const mapDispatchToProps = {
  updateViews: updateWorklistViews,
};

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(ManageViews);
